// extracted by mini-css-extract-plugin
export default {"image":"ErrorPage_image__PDBp2"};